import type { SxProps, Theme } from '@mui/material';

export const styles = {
    card: (theme: Theme): SxProps<Theme> => ({
        p: { xs: 1, md: 2 },
        borderRadius: '8px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[1],
        mt: 2,
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    }),
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
        flexShrink: 0,
        flexWrap: 'wrap',
        gap: 1,
    } as SxProps<Theme>,
    tableContainer: {
        flex: 1,
        minHeight: 0,
        overflow: 'auto',
    } as SxProps<Theme>,
    titleBlock: {
        display: 'flex',
        flexDirection: 'column',
    } as SxProps<Theme>,
    title: { fontSize: '16px', fontWeight: 600 } as SxProps<Theme>,
    subtitle: { fontSize: '12px', color: 'grey.500' } as SxProps<Theme>,
    actions: {
        display: 'flex',
        gap: 1,
        alignItems: 'center',
    } as SxProps<Theme>,
    addButton: (theme: Theme): SxProps<Theme> => ({
        backgroundColor: theme.palette.blue[700],
        color: theme.palette.white,
        textTransform: 'none',
        '&:hover': { backgroundColor: theme.palette.blue[800] },
    }),
    placeholder: {
        py: 4,
        textAlign: 'center',
        color: 'grey.500',
    } as SxProps<Theme>,
    chip: (theme: Theme): SxProps<Theme> => ({
        display: 'inline-block',
        px: 1,
        py: 0.25,
        borderRadius: '4px',
        backgroundColor: theme.palette.yellow[30],
        color: theme.palette.yellow[900],
        fontSize: '11px',
        fontWeight: 500,
    }),
    quoteRequired: {
        fontStyle: 'italic',
        color: 'grey.500',
    } as SxProps<Theme>,
    groupSep: (theme: Theme): SxProps<Theme> => ({
        backgroundColor: theme.palette.grey[40],
    }),
};
